export default __webpack_public_path__ + "static/media/afdi.f2c4ed98.svg";